import React, {Component} from 'react';

import '../sass/cgu.scss';

import Footer from '../components/Footer';
import CguText from '../components/cgu/CguText';

import {getLocale, dt, t} from 'l10n';
import {Helmet} from "react-helmet";

class Cgu extends Component {

    constructor(props) {
        super(props);

        this.state = {};

    }

    render() {

        return (
            <div id="wrapper" className="cgu-wrapper">
                <Helmet>
                    <title>
                        {dt('meta', 'The general conditions of use of Bob’s sites')}
                    </title>
                    <meta name="description"
                          content={dt('meta', 'Read the regulations, conditions of use and legal information of BobTV, Bobvoyeur and Bob4men (CGU).')}/>
                </Helmet>
                <CguText lang={getLocale()}/>
                <div
                    style={{
                        width: '100%',
                        height: '100px',
                        display: 'flex',
                        alignItems: 'flex-end',
                        justifyContent: 'center'
                    }}
                >
                    <a
                        style={{color: 'black'}}
                        href={'/mntnlgls.php'}
                        onClick={(e) => {
                            e.preventDefault();
                            window.open(
                                e.currentTarget.href,
                                '_blank',
                                'width=800,height=560,status=0,scrollbars=1,toolbar=0'
                            );
                            return false;
                        }}
                    >
                        {t('Legal notice')}
                    </a>
                </div>
            </div>
        )
    }
}

export default Cgu;



// WEBPACK FOOTER //
// ./src/containers/Cgu.js